export const IS_SPLAN = false;

const ID3_URL = process.env.REACT_APP_ID3_URL || 'https://id3.expertus.com.ua';
const APP_URL = IS_SPLAN
  ? process.env.REACT_APP_SPLAN_URL || '/Splan'
  : process.env.REACT_APP_PLAN_URL || '/ajax/plan/check-access';
const MAIN_PRODUCT = process.env.REACT_APP_MAIN_PRODUCT || 8214;
const PRODUCT_VERSION = process.env.REACT_APP_PRODUCT_VERSION || 881;

export { ID3_URL, APP_URL, MAIN_PRODUCT, PRODUCT_VERSION };
